import { render, staticRenderFns } from "./DadosRemetenteDestinatario.vue?vue&type=template&id=6c441df0"
import script from "./DadosRemetenteDestinatario.vue?vue&type=script&lang=js"
export * from "./DadosRemetenteDestinatario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports